import React, {useEffect, useRef} from 'react';
import {Button, DatePicker, Descriptions, Form, Input, InputNumber, Modal, Select, Spin, Table} from 'antd';
import {updatecwsrdj, getcwsrdj} from "../../lib/api_cw_srdj";
import {getDetail, postAdd} from "../../lib/api_cw_zcfkd";
import moment from "moment";
import Decimal from "decimal.js";

/**
 * 付款单弹窗
 * @param onCancel
 * @param onOk
 * @returns {JSX.Element}
 * @constructor
 */
const ZcfkdEditModal = ({list, onCancel, onOk}) => {
    const [loading, setLoading] = React.useState(false);
    const printContentRef = useRef(null);
    
    // 从本地存储获取初始值
    const getStoredValue = (key, defaultValue = '') => {
        try {
            const stored = localStorage.getItem(`zcfkd_${key}`);
            return stored || defaultValue;
        } catch (error) {
            console.error('读取本地存储失败:', error);
            return defaultValue;
        }
    }
    
    // 保存到本地存储
    const saveToStorage = (key, value) => {
        try {
            localStorage.setItem(`zcfkd_${key}`, value);
        } catch (error) {
            console.error('保存到本地存储失败:', error);
        }
    }
    
    const [huhao, setHuhao] = React.useState(getStoredValue('huhao'));
    const [zhanghao, setZhanghao] = React.useState(getStoredValue('zhanghao'));
    const [kaihuhang, setKaihuhang] = React.useState(getStoredValue('kaihuhang'));
    const [hjje, setHjje] = React.useState('0');

    // 更新状态并保存到本地存储
    const updateHuhao = (value) => {
        setHuhao(value);
        saveToStorage('huhao', value);
    }
    
    const updateZhanghao = (value) => {
        setZhanghao(value);
        saveToStorage('zhanghao', value);
    }
    
    const updateKaihuhang = (value) => {
        setKaihuhang(value);
        saveToStorage('kaihuhang', value);
    }

    useEffect(() => {
        let total = new Decimal('0');
        console.log(list);
        list.forEach(item => {
            total = total.plus(item.je);
        });
        setHjje(total.toFixed(2));
    }, [list]);

    const handleOk = () => {
        onOk && onOk();
    }
    const handleCancel = () => {
        onCancel && onCancel();
    }

    const handleSaveAndPrint = () => {
        setLoading(true);
        postAdd({
            huhao,
            zhanghao,
            kaihuhang,
            ids: list.map(item => item.id),
        }).then((res) => {
            if (res.code === 0) {
                // message.success(res.message);
                onOk && onOk(res.data.id);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <Modal
            title="付款单详情"
            open={true}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
            width={1000}
            footer={false}
            style={{top: 20}}
        >
            {/*打印按钮*/}
            <Button type="primary" onClick={handleSaveAndPrint}>生成付款单并打印</Button>
            <Spin spinning={loading}>
                <div ref={printContentRef}>
                    <Descriptions title="付款单详情" column={1}>
                        <Descriptions.Item label="创建日期">{moment().format('YYYY-MM-DD')}</Descriptions.Item>
                        <Descriptions.Item label="付款金额">{hjje}</Descriptions.Item>
                        <Descriptions.Item label="笔数">{list.length}</Descriptions.Item>
                        <Descriptions.Item label="户名">
                            <Input value={huhao} onChange={(e) => updateHuhao(e.target.value)} style={{width: 200}}/>
                        </Descriptions.Item>
                        <Descriptions.Item label="账号">
                            <Input value={zhanghao} onChange={(e) => updateZhanghao(e.target.value)} style={{width: 200}}/>
                        </Descriptions.Item>
                        <Descriptions.Item label="开户行">
                            <Input value={kaihuhang} onChange={(e) => updateKaihuhang(e.target.value)}
                                   style={{width: 200}}/>
                        </Descriptions.Item>
                    </Descriptions>
                    <Table
                        columns={[
                            {
                                title: '审批编号',
                                dataIndex: 'sp_no',
                                key: 'sp_no',
                                width: 150,
                                fixed: 'left',
                            },
                            {
                                title: '来源',
                                dataIndex: 'ly',
                                key: 'ly',
                                width: 100,
                                fixed: 'left',
                            },
                            {
                                title: '提交日期',
                                dataIndex: 'date',
                                key: 'date',
                                width: 130,
                            },
                            {
                                title: '金额',
                                dataIndex: 'je',
                                key: 'je',
                                width: 130,
                            },
                            {
                                title: '事由',
                                dataIndex: 'bz',
                                key: 'bz',
                            },
                        ]}
                        dataSource={list}
                        pagination={false}
                    />
                </div>
            </Spin>
        </Modal>
    )
}

export default ZcfkdEditModal;
